import { isEmpty } from 'lodash'
import { ValidatorResult } from 'Modules'

export const orgNameValidate = (org_name: string) => {
	const validate = new ValidatorResult()
	if (org_name && org_name.length > 75) {
		validate.error.code = 'max_count_75'
	} else if (
		org_name &&
		org_name.toLowerCase().indexOf('общество с ограниченной ответственностью') > -1
	) {
		validate.error.code = 'org_name_automat'
	}
	// eslint-disable-next-line no-empty
	else if (isEmpty(org_name) || !org_name.match(/"/g)) {
	} else if (org_name.match(/"/g).length % 2 !== 0) {
		validate.error.code = 'found_no_close_quotes'
	} else if (org_name[0] === '"' && org_name[org_name.length - 1] === '"') {
		validate.error.code = 'quotes_cannot_be_extreme'
	} else {
		validate.result = true
	}
	return validate
}

export const internationalOrgNameValidate = (international_org_name: string) => {
	const validate = new ValidatorResult()
	if (international_org_name && international_org_name.length > 91) {
		validate.error.code = 'max_count_91'
	} else if (
		international_org_name &&
		international_org_name.toLowerCase().indexOf('limited liability company') > -1
	) {
		validate.error.code = 'international_org_name_automat'
	}
	// eslint-disable-next-line no-empty
	else if (isEmpty(international_org_name) || !international_org_name.match(/"/g)) {
	} else if (international_org_name.match(/"/g).length % 2 !== 0) {
		validate.error.code = 'found_no_close_quotes'
	} else if (international_org_name[0] === '"') {
		validate.error.code = 'quotes_cannot_be_extreme'
	} else {
		validate.result = true
	}
	return validate
}

export const orgShortNameValidate = (org_short_name: string) => {
	const validate = new ValidatorResult()
	if (org_short_name && org_short_name.length > 112) {
		validate.error.code = 'max_count_112'
	} else if (org_short_name && org_short_name.toLowerCase().indexOf('ооо') === 0) {
		validate.error.code = 'org_short_name_automat'
	}
	// eslint-disable-next-line no-empty
	else if (isEmpty(org_short_name) || !org_short_name.match(/"/g)) {
	} else if (org_short_name.match(/"/g).length % 2 !== 0) {
		validate.error.code = 'found_no_close_quotes'
	} else if (org_short_name[0] === '"' && org_short_name[org_short_name.length - 1] === '"') {
		validate.error.code = 'quotes_cannot_be_extreme'
	} else {
		validate.result = true
	}
	return validate
}

export const intOrgShortNameValidate = (international_org_short_name: string) => {
	const validate = new ValidatorResult()
	if (international_org_short_name && international_org_short_name.length > 112) {
		validate.error.code = 'max_count_112'
		validate.error.message = 'Максимальная длина 112 символов'
	} else if (
		international_org_short_name &&
		international_org_short_name.toLowerCase().indexOf('llc') === 0
	) {
		validate.error.code = 'international_org_short_name_automat'
	}
	// eslint-disable-next-line no-empty
	else if (isEmpty(international_org_short_name) || !international_org_short_name.match(/"/g)) {
	} else if (international_org_short_name.match(/"/g).length % 2 !== 0) {
		validate.error.code = 'found_no_close_quotes'
	} else if (
		international_org_short_name[0] === '"' &&
		international_org_short_name[international_org_short_name.length - 1] === '"'
	) {
		validate.error.code = 'quotes_cannot_be_extreme'
	} else {
		validate.result = true
	}
	return validate
}

export const validatePassportSeriesRedux = (value: string) => {
	const validate = new ValidatorResult()
	if (value.length !== 4 || !+value) {
		validate.error.code = 'bad_format'
	} else {
		validate.result = true
	}
	return validate
}
export const validatePassportNumberRedux = (value: string) => {
	const validate = new ValidatorResult()
	if (value.length !== 6 || !+value) {
		validate.error.code = 'bad_format'
	} else {
		validate.result = true
	}
	return validate
}

export const validatePassport = (value: string) => {
	const validate = new ValidatorResult()
	if (value.length !== 11) {
		validate.error.code = 'bad_format'
	} else {
		validate.result = true
	}
	return validate
}
